export enum Modes {
  DEVELOPER,
  SYSTEM_ADMIN,
  COMPANY_ADMIN,
  REAL_ESTATE_ADMIN,
}
